<section>
  <mbs-alert
    [icon]="true"
    [type]="mbsPopupType.info">
    {{ 'wizards:ibbRestoreTypeWizard.restoreTypeInfoAlert' | i18next: { typeText: selectedTypeLabel() } }}
  </mbs-alert>

  <div class="mb-3">
    @if (requirements().length) {
      <h5 class="mt-0 mb-2">{{ 'wizards:ibbRestoreTypeWizard.requirements.title' | i18next }}</h5>

      <ul class="mb-0 pl-4">
        @for (requirement of requirements(); track requirement) {
          <li>{{ requirement }}</li>
        }
      </ul>
    }
  </div>

  @if (!restoreToHidden()) {
    <h5 class="mt-0 mb-2">{{ 'shared:generic.restoreTo' | i18next }}</h5>

    <mbs-radio
      class="mb-2"
      name="isLocal"
      [descriptionOutside]="false"
      [disabledSelf]="!isOnline()"
      [id]="'is-local-restore-2'"
      [label]="sourceComputerLabel"
      [ngModel]="restoreTo()"
      [value]="restoreTypeFromStorageTab.current"
      (ngModelChange)="restoreTo.set($event)">
      <ng-template #sourceComputerLabel>
        {{ (isRemote() ? 'shared:generic.restoreToCurrent' : 'shared:generic.originalComputer') | i18next }} ({{ computerName() }})

        @if (currentComputerHyperVChecking()) {
          <span class="loader loader-sm loader-primary ml-1"></span>
        }
      </ng-template>
      <ng-template
        radioDescription
        [hide]="isOnline() && !currentComputerHyperVMissing()">
        @if (!isOnline()) {
          <span class="text-xs text-gray-500">{{ 'shared:generic.isOffline' | i18next: { computer: computerName() } }}</span>
        } @else if (currentComputerHyperVMissing()) {
          <span class="text-xs text-warning">{{ 'wizards:hyperVNotInstalled' | i18next }}</span>
        }
      </ng-template>
    </mbs-radio>

    @if (canRestoreToDifferentComputer()) {
      <mbs-radio
        class="mb-2"
        name="isLocal"
        [descriptionOutside]="false"
        [id]="'is-local-restore-3'"
        [label]="'shared:generic.differentComputer' | i18next"
        [ngModel]="restoreTo()"
        [value]="restoreTypeFromStorageTab.different"
        (ngModelChange)="restoreToChangeHandler($event)">
        <ng-template radioDescription>
          @let toComputer = selectedComputer();
          <mbs-button
            [disabled]="restoreTo() !== restoreTypeFromStorageTab.different"
            [isCtrl]="true"
            (click)="selectComputerClickHandler()">
            {{ toComputer?.name || ('shared:generic.selectComputer' | i18next) }}

            @if (selectedComputerHyperVChecking()) {
              <span class="loader loader-sm loader-primary ml-1"></span>
            }

            @if (toComputer && restoreTo() === restoreTypeFromStorageTab.different) {
              @if (!isOnlineSecondComputer()) {
                <span class="text-xs text-warning ml-1"> ({{ 'shared:generic.selectOnlineWithWindowsOs' | i18next }}) </span>
              }
              @if (isOnlineSecondComputer() && !isSupportTokenSecondComputer()) {
                <span class="text-xs text-warning ml-1"> ({{ 'shared:generic.selectWithAgentVersion' | i18next }}) </span>
              }
              @if (selectedComputerHyperVMissing()) {
                <span class="text-xs text-warning ml-1"> ({{ 'wizards:hyperVNotInstalled' | i18next }}) </span>
              }
            }
          </mbs-button>
        </ng-template>
      </mbs-radio>
    }
  }
</section>
